<template>
    <div class="net-body net-order-counting" v-loading="loading">
        <div class="net-body-head">
            <div class="net-head-label">
                <div class="labelBox">
                    {{ item.label }}
                </div>
                <el-date-picker
                    class="searchBox"
                    v-model="searchDate"
                    type="daterange"
                    range-separator="至"
                    value-format="yyyy-MM-dd"
                    @change="onSearchChange"
                    @blur="onblur"
                    :picker-options="pickerOptions"
                    :clearable="false"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <div class="updateTimeTip" v-show="NOCData.w_insert_dt">更新时间：{{NOCData.w_insert_dt}}</div>
            </div>
            <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="net-workbench-pop"
            >
                <!-- <div class="net-popover-css" @click="tomoreFn">更多</div> -->
                <div class="net-popover-css" @click="closeUp(item.prop)">关闭</div>
                <i slot="reference" class="el-icon-more i-style"></i>
            </el-popover>
        </div>
        <div class="net-content">
            <ul class="order-list-box">
                <li
                    class="order-list-item"
                    v-for="(item, index) in config.orderItemList"
                    :key="index"
                    @click="checkData(jumpParam[item.prop])"
                >
                    <div class="item-carrybox">
                        <div :class="'item-carrybox-L ' + item.bgc">
                            <img :src="item.iconUrl" />
                        </div>
                        <div class="item-carrybox-R">
                            <span>{{ NOCData[item.prop] }}</span>
                            <span>{{ item.label }}</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import config from './netOrderCountingConfig';
import { getNetTablesInfo } from '../../../api/manaDesk.js';

export default {
    props: {
        item: {
            type: Object
        },
        disabledDays: {
            type: String,
            default() {
                return '15';
            }
        },
        earliestDay: {
            type: String,
            default() {
                return '90';
            }
        }
    },
    data() {
        return {
            loading: false,
            config: config,
            paramsDateList: [],
            dataList: [],
            NOCData: {},
            searchDate: [
                dayjs().format('YYYY-MM-DD'),
                dayjs().format('YYYY-MM-DD')
            ],
            jumpParam: {
                pick_order_num: {
                    orderStatus: ['30']
                },
                on_order_inventory: {
                    orderStatus: ['40']
                },
                sign_order_num: {
                    orderStatus: ['100']
                },
                booking_order_num: {
                    orderStatus: ['120']
                },
                dispatching_order_num: {
                    orderStatus: ['140', '145']
                },
                receipt_order_num: {
                    orderStatus: ['230']
                },
                review_order_num: {
                    orderStatus: ['160', '170', '195', '300']
                },
                complete_order_num: {
                    orderStatus: ['880', '180', '210', '200']
                }
            },
            disabledDaysTime: this.disabledDays * 24 * 60 * 60 * 1000,
            earliestDayTime: this.earliestDay * 24 * 60 * 60 * 1000,
            pickedMinDate: '',
            pickerOptions: {
                onPick: ({ minDate, maxDate }) => {
                    this.pickedMinDate = minDate;
                },
                disabledDate: (time) => {
                    if (this.pickedMinDate) {
                        const minTime = time.getTime() + this.disabledDaysTime;
                        const maxTime = time.getTime() - this.disabledDaysTime;
                        // 前后跨度、今天后不可查、最远可查限制
                        const flag = this.pickedMinDate > minTime || this.pickedMinDate < maxTime || time.getTime() > Date.now() || time.getTime() < Date.now() - this.earliestDayTime;
                        return flag;
                    }
                    return time.getTime() > Date.now() || time.getTime() < Date.now() - this.earliestDayTime;
                }
            }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            this.paramsDateList = [];
            this.dataList = [];
            this.NOCData = {
                pick_order_num: 0, // 接单量
                on_order_inventory: 0, // 在途量
                sign_order_num: 0, // 网点签收
                booking_order_num: 0, // 预约量
                dispatching_order_num: 0, // 派工量
                receipt_order_num: 0, // 入库量
                review_order_num: 0, // 审核量
                complete_order_num: 0, // 完成量
                w_insert_dt: ''
            };
            const param = {
                type: 'cpkb_wdkb_lzqj',
                exportOrgId: "\"{'match_all':{}}\"",
                sqlParams: {
                    start_date: this.searchDate[0],
                    end_date: this.searchDate[1]
                },
                auth: '{}',
                sourceType: 'es',
                nameMap: {
                    network_code: 'D20191223001',
                    network_center_code: 'D20201126001'
                },
                groupList: [
                    'network_code',
                    'network_center_code'
                ],
                logicalSymbolList: [
                    'or'
                ],
                refresh: true
            };
            await getNetTablesInfo(param).then(res => {
                if (res && res.code === '0' && res.data.length) {
                    res.data.forEach(item => {
                        this.NOCData.pick_order_num += item.pick_order_num.value;
                        this.NOCData.on_order_inventory += item.on_order_inventory.value;
                        this.NOCData.sign_order_num += item.sign_order_num.value;
                        this.NOCData.booking_order_num += item.booking_order_num.value;
                        this.NOCData.dispatching_order_num += item.dispatching_order_num.value;
                        this.NOCData.receipt_order_num += item.receipt_order_num.value;
                        this.NOCData.review_order_num += item.review_order_num.value;
                        this.NOCData.complete_order_num += item.complete_order_num.value;
                        if (!this.NOCData.w_insert_dt && item.w_insert_dt) {
                            this.NOCData.w_insert_dt = item.w_insert_dt.buckets[0].key_as_string.split(' ')[1].split(',')[0];
                        }
                    });
                }
            }).catch(() => {});
            this.$nextTick(() => {
                this.loading = false;
            });
        },
        onSearchChange(param) {
            this.getData();
        },
        onblur() {
            // 清除最小时间限制
            this.pickedMinDate = '';
        },
        // 跳转到网点任务管理页面
        checkData(params) {
            this.$router.push({
                query: {
                    ...params,
                    getData: true,
                    startTime: this.searchDate[0] + ' 00:00:00',
                    endTime: this.searchDate[1] + ' 23:59:59'
                },
                path: '/net-task'
            });
        },
        closeUp() {
            this.$emit('closeUp', this.item.prop);
        },
        tomoreFn() {}
    }
};
</script>

<style lang="less">
.net-order-counting {
    margin-bottom: 10px;
    .searchBox {
        width: 320px;
        margin-left: 20px;
        margin-top: -4px;
    }
    .order-list-box {
        display: flex;
        overflow: auto;
        // justify-content: space-around;
        // flex-wrap: wrap;
        .order-list-item {
            cursor: pointer;
            margin: 0px 10px 10px 0;
            padding: 20px;
            // background: #f8756c;
            background: #f8f8f9;
            border-radius: 4px;
            transition: box-shadow 0.15s ease;
            // transition: scale 0.25s ease;
            &:hover {
                .item-carrybox-R>span:first-child {
                    color: #00bcbf;
                }
                // transform: scale(0.95,0.95);
                box-shadow: 0px 0px 12px -3px  #ccc;
            }
        }
    }
    .item-carrybox {
        width: 100%;
        display: flex;
    }
    .item-carrybox-L {
        flex-shrink: 0;
        height: 30px;
        width: 30px;
        margin-top: 9px;
        text-align: center;
        border-radius: 100%;
        > img {
            margin-top: 6px;
            height: 18px;
            vertical-align: middle;
        }
    }
    .order_quantity_bgc {
        background-color: #24c100;
    }
    .transit_bgc {
        background-color: #f55742;
    }
    .sign_bgc {
        background-color: #00c9cc;
    }
    .booked_bgc {
        background-color: #ff796e;
    }
    .dispatch_bgc {
        background-color: #ffb127;
    }
    .warehousing_bgc {
        background-color: #4561ff;
    }
    .warehouse_out_bgc {
        background-color: #458fff;
    }
    .complete_bgc {
        background-color: #2c2931;
    }
    .item-carrybox-R {
        flex-shrink: 0;
        margin-left: 10px;
        span:first-child {
            display: block;
            height: 25px;
            line-height: 25px;
            font-size: 18px;
            font-weight: 600;
            color: #333;
        }
        span:last-child {
            display: block;
            margin-top: 2px;
            width: 58px;
            height: 17px;
            line-height: 17px;
            font-size: 12px;
            color: #888;
        }
    }
}
</style>